import { render, staticRenderFns } from "./CompletarCadastro.vue?vue&type=template&id=b8608796&"
import script from "./CompletarCadastro.vue?vue&type=script&lang=js&"
export * from "./CompletarCadastro.vue?vue&type=script&lang=js&"
import style0 from "./CompletarCadastro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports